import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UrlSearchValueObject} from '../ValueObjects/UrlSearchValueObject.js'

class GetUrlParamsSearchUseCase extends UseCase {
  #config

  constructor({config}) {
    super()
    this.#config = config
  }

  static create({config}) {
    return new GetUrlParamsSearchUseCase({config})
  }

  @tracer({metric: 'GetUrlParamsSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({listingSectionId, search}) {
    return UrlSearchValueObject.createFromSearch({
      config: this.#config,
      listingSectionId,
      search
    })
  }
}

export const factory = GetUrlParamsSearchUseCase.create
